export default [{
  path: 'deployments',
  name: 'deploymentsRoot',
  component: () => import(/* webpackChunkName: "deployments" */ './Deployments.vue'),
},
{
  path: 'deployments/:id',
  name: 'deploymentsDetail',
  component: () => import(/* webpackChunkName: "deployments" */ './DeploymentDetail.vue'),
}];
